
import { Component, Vue } from 'vue-property-decorator'
import TermsCheckbox from '@/checkout/components/TermsCheckbox.vue'

@Component({ name: 'ElementsStory', components: { TermsCheckbox } })
export default class extends Vue {}
